// ============================================================
// AWS Cognito Configuration
// credentials from the AWS Console.
// ============================================================

export const awsExports = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_sDRs3fWZI',
      userPoolClientId: '4kq5hk9htmu2bm80aank9g00v4',
      loginWith: {
        email: true,
        // OAuth must be nested here (not at Cognito root level) for Amplify v6.
        // Domain must NOT include https:// — Amplify adds the scheme itself.
        // redirectSignIn / redirectSignOut must be arrays.
        oauth: {
          domain: 'us-east-2sdrs3fwzi.auth.us-east-2.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: ['http://localhost:4200/panel/subscription', 'https://clientes.cronicadelquindio.com/panel/subscription'],
          redirectSignOut: ['http://localhost:4200/login', 'https://clientes.cronicadelquindio.com/login'],
          responseType: 'code',
        },
      },
    },
  },
};
